import { useRoutes, type RouteObject } from 'react-router-dom'
import { useGetProfileQuery } from '../api'
import { isProfileComplete } from '../utils/profile/isProfileComplete'
import { guestRoutes } from './routerGuest'
import { profileRoutes } from './routerProfile'
import { profileOnboardingRoutes } from './routerProfileOnboarding'
import { AuthBootstrapSpinner } from './AuthBootstrapSpinner'

const authLoadingRoutes: RouteObject[] = [
  {
    path: '*',
    element: <AuthBootstrapSpinner />,
  },
]

export const Routes = () => {
  const {
    data: user,
    isLoading,
    isError,
    isUninitialized,
  } = useGetProfileQuery(undefined, {
    refetchOnFocus: false,
    refetchOnReconnect: false,
  })

  let routes: RouteObject[] = guestRoutes

  const profilePending = isUninitialized || isLoading

  if (profilePending) {
    routes = authLoadingRoutes
  } else if (isError || user == null) {
    routes = guestRoutes
  } else if (user.deleted) {
    routes = profileRoutes
  } else if (!isProfileComplete(user)) {
    routes = profileOnboardingRoutes
  } else {
    routes = profileRoutes
  }

  return useRoutes(routes)
}
